<template>
    <section class="component-bed1ea29" resmed-component-name="feature_sleep_assessment_text_cta_graphic"
        v-bind:style="{
            'background-image': `url(${acf.layout['background-image']})`,
            'background-color': acf.layout['background-color']
        }">
        <div class="component">
            <div class="container px-xs-sm-2">
                <div class="row">
                    <div class="col-md-6 col-xl-5 offset-lg-1 content order-2 order-md-0">
                        <h1 v-html="acf.headline"></h1>
                        <div class="pt-3 pb-4" v-html="acf.introduction"></div>

                        <div class="call-to-action">
                            <a href="#" v-on:click.prevent="scroll({ to: '.component-a7efd289' })" v-bind:target="acf.cta.target" class="btn cta-pill filled-red icon right-arrow">{{ acf.cta.text }}</a>
                            <span class="duration d-inline-block">{{ acf.duration }}</span>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4 offset-lg-1 offset-xl-2">
                        <figure v-bind:style="transform" class="px-4 px-md-0">
                            <img class="img-fluid d-block d-md-none" v-bind:src="acf.illustration['illustration-xs']" alt="">
                            <img class="img-fluid d-none d-md-block" v-bind:src="acf.illustration['illustration-md']" alt="">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { scroll } from '../../mixins/index';

    export default {
        name: 'component-bed1ea29', // feature_sleep_assessment_text_cta_graphic
        props: ['acf'],
        data() {
            return {
                transform: {
                    transform: 'translate(0, 0)'
                }
            }
        },
        mixins: [ scroll ],
        watch: {
            '$root.mode': {
                handler(val) {
                    if ( val === 'xs' || val === 'sm' ) {
                        this.transform['transform'] = this.acf.layout['transform']['transform-xs'];
                    }
                    if ( val === 'md' ) {
                        this.transform['transform'] = this.acf.layout['transform']['transform-md'];
                    }
                    if ( val === 'lg' || val === 'xl' ) {
                        this.transform['transform'] = this.acf.layout['transform']['transform-lg'];
                    }

                },
                immediate: true
            }
        },
        created() {
            bus.$emit('navigation:reversed', true);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../css/abstracts/path";
    @import "../../css/abstracts/colors";
    @import "../../css/base/typography";

    .component-bed1ea29 {
        background-size: cover;
        background-position: center top;
        background-repeat: no-repeat;
    }

    .component {
        padding: 2rem 0 5rem 0;

        @media (max-width: 767px) {
            min-height: 100vh;

            figure  {
                img {
                    &:first-child {
                        max-width: 220px;
                        margin: 0 auto;
                    }
                }
            }
        }

        @media (min-width: 768px) {
            padding: 6rem 0 9rem 0;
        }

        .content * {
            color: $cc-resmed-white;
        }

        h1 {
            margin: 0;
            color: rgba($cc-resmed-white, .875);
        }

        .duration {
            @extend %body-small-bold;
            color: $cc-resmed-white;
            margin-left: 1.25rem;
            padding-left: 1.875rem;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4gICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiNGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIj4gICAgICAgIDxjaXJjbGUgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+ICAgICAgICA8cGF0aCBkPSJNMTAgNHY2bDQgMiIvPiAgICA8L2c+PC9zdmc+);
            background-position: left center;
            background-size: 1.125rem;
            background-repeat: no-repeat;
        }
    }
</style>